export enum ReportFilterCategory {
  Date = "Date",
  Hierarchy = "Hierarchy",
  Additional = "Additional",
  Columns = "Columns",
}
